export default __webpack_public_path__ + "static/media/webapp.0ae9596b.jpg";